<app-material>
    <div class="header" header>
        <h2>{{ 'service.tickets.table.title' | translate }}</h2>
        <div class="mutators">
            <app-icon class="toggle" library="material" variant="filter_list"
                      (click)="toggleFilters()"></app-icon>
        </div>
    </div>
    <div class="content" body>
        <app-service-tickets-table [tickets]="tickets"
                                   [tableConfig]="tableConfig"
                                   [isLoading]="isLoading"
                                   [hasFilters]="hasFilters"
                                   [hasTitle]="false"
                                   [isMaterial]="false"
                                   [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                   (sortChange)="onSortChange($event)"
                                   (filterChange)="onFilter($event)"
                                   (pageChange)="onPageChange($event)"
                                   (rowClick)="onTableRowClick($event)">
        </app-service-tickets-table>
    </div>
</app-material>
